'use client'

import { HStack, VStack } from '@/components/Atoms'
import { Label } from '@repo/ui/components'
import { useTranslation } from 'react-i18next'
import { DateFilter } from '../../DateFilter'
import { Container } from './Container'

export type DateRange = {
  from: Date | undefined
  to: Date | undefined
}

type DateRangeFilterProps = {
  name: string
  title: string
  value: DateRange
  setValue: React.Dispatch<React.SetStateAction<DateRange>>
}

export function DateRangeFilter(props: DateRangeFilterProps) {
  const { t } = useTranslation('common')
  const hasDateSelected = props.value.from !== undefined || props.value.to !== undefined

  const handleReset = () => {
    props.setValue({ from: undefined, to: undefined })
  }

  const handleFromSelect = (date: Date | undefined) => {
    props.setValue({ ...props.value, from: date })
  }

  const handleToSelect = (date: Date | undefined) => {
    props.setValue({ ...props.value, to: date })
  }

  return (
    <Container
      isResetVisible={hasDateSelected}
      onReset={handleReset}
      hasOptionsSelected={hasDateSelected}
      title={props.title}
    >
      <HStack gap="sm" className="w-full">
        <VStack gap="xs" className="flex-1">
          <Label htmlFor={`${props.name}-from`} className="text-muted-foreground text-xs">
            {t('dateRange.from')}
          </Label>
          <DateFilter
            variant="secondary"
            className="w-full"
            defaultDate={props.value.from}
            onSelect={handleFromSelect}
          />
        </VStack>
        <VStack gap="xs" className="flex-1">
          <Label htmlFor={`${props.name}-to`} className="text-muted-foreground text-xs">
            {t('dateRange.to')}
          </Label>
          <DateFilter
            variant="secondary"
            className="w-full"
            defaultDate={props.value.to}
            onSelect={handleToSelect}
            fromDate={props.value.from}
          />
        </VStack>
      </HStack>
    </Container>
  )
}
